import type { CSSProperties, ReactNode } from 'react'
import { Link } from 'react-router-dom'

// The page frame the sign-up steps share: logo bar, then a centred white card with a heading.
const theme = {
  '--bg-primary': '#F7FAF7', '--forest-green': '#1B5E20', '--emerald': '#2E7D32', '--bg-tint': '#E8F5E9',
  '--slate': '#4A5568', '--slate-light': '#718096', '--border': '#E2E8F0', '--text-primary': '#1A202C',
  '--text-secondary': '#4A5568', '--text-muted': '#A0AEC0', '--error-bg': '#FED7D7', '--error-text': '#C53030',
  '--error-border': '#FC8181', '--success-bg': '#C6F6D5', '--success-text': '#276749', '--success-border': '#9AE6B4',
} as CSSProperties

export default function AuthCardLayout({ title, subtitle, children }: { title: string; subtitle: string; children: ReactNode }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', ...theme }}>
      <header style={{ background: '#fff', borderBottom: '1px solid var(--border)', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, padding: '1rem 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(1rem, 4vw, 2rem)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
            <img src="/IGotThat_logo_bk.svg" alt="I Got That U.S." width={230} height={34} style={{ width: '230px', height: 'auto', display: 'block' }} />
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8" style={{ paddingTop: '0', paddingBottom: '80px', background: 'var(--bg-primary)', minHeight: 'calc(100vh - 72px)' }}>
        <div style={{ width: '100%', maxWidth: '520px', padding: '1rem' }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: 'clamp(1.5rem, 5vw, 2.5rem)', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', border: '1px solid var(--border)' }}>
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <h1 style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 0.5rem 0' }}>{title}</h1>
              <p style={{ color: 'var(--slate)', margin: 0 }}>{subtitle}</p>
            </div>
            {children}
          </div>
        </div>
      </main>
    </div>
  )
}

export const fieldLabelStyle: CSSProperties = { display: 'block', fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: '0.25rem' }
export const fieldInputStyle: CSSProperties = { width: '100%', padding: '0.75rem 1rem', border: '1px solid var(--border)', borderRadius: '8px', fontSize: '1rem' }
export const errorBoxStyle: CSSProperties = { marginBottom: '1rem', padding: '0.75rem 1rem', borderRadius: '8px', background: 'var(--error-bg)', color: 'var(--error-text)', fontSize: '0.875rem', border: '1px solid var(--error-border)' }
export const primaryButtonStyle = (disabled: boolean): CSSProperties => ({
  width: '100%', padding: '0.75rem 1rem', background: 'var(--forest-green)', color: 'white', fontWeight: 600, fontSize: '1rem',
  borderRadius: '8px', border: 'none', cursor: disabled ? 'not-allowed' : 'pointer', transition: 'all 0.2s', opacity: disabled ? 0.5 : 1, marginTop: '0.5rem',
})
